import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { jiemi } from '@/utils/ruoyi'

NProgress.configure({ showSpinner: false })

const whiteList = [jiemi("L3N5cy9hZG1pbi9tYW5hZ2VtZW50L2xvZ2lu"), '/auth-redirect', '/bind', '/register', '/home/index', '/home/history']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    /* has token*/
    if (to.path === jiemi("L3N5cy9hZG1pbi9tYW5hZ2VtZW50L2xvZ2lu")) {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => {
          // 拉取user_info
          const roles = res.roles
          store.dispatch('GenerateRoutes', { roles }).then(accessRoutes => {
          // 测试 默认静态页面
          // store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          })
        })
          .catch(err => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err)
              next({ path: '/' })
            })
          })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      console.log("请求后缀：",to.path)
      console.log("请求地址：",to.fullPath)
      console.log("是否是complain后缀",to.path.indexOf("/complain")!= -1)
      if(to.path.indexOf("/complain")!= -1){
        next('/sys/admin/management/login') // 否则全部重定向到登录页
        NProgress.done()
      }else {
        next('/home/index') // 否则重定向到投诉首页
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
